var _rect, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "url(#paint0_linear_1939_4750)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8238 3.86089C39.6304 2.23824 42.3696 2.23823 44.1762 3.86088L50.0968 9.17854C51.2986 10.2579 52.8714 10.8304 54.4859 10.776L62.4394 10.5081C64.8664 10.4264 66.9648 12.1871 67.3057 14.5914L68.423 22.4707C68.6498 24.07 69.4867 25.5196 70.7584 26.5156L77.0233 31.4229C78.9351 32.9203 79.4107 35.6179 78.1264 37.6788L73.9177 44.4329C73.0634 45.8038 72.7727 47.4522 73.1066 49.0327L74.7515 56.8189C75.2535 59.1948 73.8839 61.567 71.5753 62.3203L64.0098 64.7888C62.4741 65.2899 61.1919 66.3658 60.4318 67.7911L56.687 74.813C55.5443 76.9557 52.9703 77.8926 50.7176 76.9857L43.3354 74.0137C41.8369 73.4104 40.1631 73.4104 38.6646 74.0137L31.2824 76.9857C29.0297 77.8926 26.4557 76.9557 25.313 74.813L21.5682 67.7911C20.8081 66.3658 19.5259 65.2899 17.9902 64.7888L10.4247 62.3203C8.11613 61.567 6.74652 59.1948 7.24846 56.8189L8.8934 49.0327C9.22729 47.4522 8.93664 45.8038 8.08233 44.4329L3.87357 37.6788C2.58928 35.6179 3.06494 32.9203 4.97666 31.4229L11.2416 26.5156C12.5133 25.5196 13.3502 24.07 13.577 22.4707L14.6943 14.5914C15.0352 12.1871 17.1336 10.4264 19.5606 10.5081L27.5141 10.776C29.1286 10.8304 30.7014 10.2579 31.9032 9.17854L37.8238 3.86089Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.9996,
    cy: 41.0003,
    r: 19.3372,
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5035 36.4595L38.6612 45.54L34.9464 41.5501",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1939_4750",
    x1: 44.5,
    y1: 26,
    x2: 44.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.92eeda142facc4eae8c010f3058731b5.svg";
export { ForwardRef as ReactComponent };